<template>
    <div>
        <Head title="Knowledge Base" />
        <!-- Start Hero -->
        <section class="relative table w-full py-20 lg:py-24 bg-gray-50 dark:bg-slate-800">
            <div class="container">
                <div class="grid grid-cols-1 text-center mt-10">
                    <h3 class="text-3xl leading-normal font-semibold">Knowledge Base</h3>
                </div><!--end grid-->
            </div><!--end container-->

        </section><!--end section-->
        <div class="relative">
            <div class="shape absolute right-0 sm:-bottom-px -bottom-[2px] left-0 overflow-hidden z-1 text-white dark:text-slate-900">
                <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <!-- End Hero -->

        <section class="relative py-16">
            <div class="container">
                <div class="flex items-center justify-center mb-12"><search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset"></search-input></div>
                <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-[30px]">
                    <div class="blog relative rounded-md shadow dark:shadow-gray-800 overflow-hidden" v-for="post in kb.data" :key="post.id">

                        <div class="content p-6">
                            <a :href="route('kb.details', post.id)" class="title h5 text-lg font-medium hover:text-indigo-600 duration-500 ease-in-out">{{ post.title }}</a>
                            <div class="text-slate-400 mt-3">
                                {{ post.details.length < 70 ? post.details : post.details.substring(0,70) + "..." }}
                            </div>
                            <div class="mt-4">
                                <a :href="route('kb.details', post.id)" class="btn btn-link font-normal hover:text-indigo-600 after:bg-indigo-600 duration-500 ease-in-out">Read More <i class="uil uil-arrow-right"></i></a>
                            </div>
                        </div>
                    </div><!--blog end-->
                </div><!--end grid-->

                <pagination class="mt-6" :links="kb.links" />
            </div><!--end container-->

            <subscribe />
        </section><!--end section-->
        <!-- End Section-->
    </div>
</template>
<script>
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import SearchInput from '@/Shared/SearchInput'
import Pagination from '@/Shared/Landing/Pagination'
import { Head } from '@inertiajs/inertia-vue3'
import Subscribe from '@/Shared/Landing/Subscribe'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import mapValues from "lodash/mapValues";
export default {
    layout: Layout,
    components: {
        Subscribe,
        Icon,
        Head,
        Pagination,
        SearchInput,
    },
    props: {
        kb: Object,
        types: Array,
        title: String,
        filters: Object,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
            },
        }
    },

    watch: {
        form: {
            deep: true,
            handler: throttle(function() {
                this.$inertia.get(this.route('kb'), pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },

    methods:{
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },

    created() {

    }
}
</script>
